/*
 * @Author: princemwang
 * @Date: 2022-07-06 17:21:18
 * @LastEditors:
 * @LastEditTime: 2022-07-06 17:22:08
 */
export const PlaySvg = () => {
  return (
    <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H3.22283V19.8318H0V0ZM9.66798 0H12.8903V19.8318H9.66798V0Z" fill="black" />
    </svg>
  );
};
